import { IFlash } from '@shared/types/flash';

interface IConfig {
  flashes: IFlash[];
}

declare const CONFIG: IConfig;

export const FLASHES = CONFIG.flashes;
